<script lang="ts" setup>
import type { FormDescriptionProps } from '@satch-ui/primitives/form/types'
import { inputHelperVariants } from '@satch-ui/primitives/form/variants'

import { FormDescription } from '@fond-of/fondof-ui'

const props = defineProps<FormDescriptionProps>()
</script>

<template>
  <FormDescription
    :class="
      inputHelperVariants({
        variant: 'default',
        class: props.class,
        padding: props.padding,
      })
    "
  >
    <slot />
  </FormDescription>
</template>
